import { useState, useEffect } from "react";
import { fetchStrains, getTypes, getStrainsByType } from "../api/cannabisApi";

export function useCannabisData() {
  const [strains, setStrains] = useState([]);
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function load() {
      try {
        const [allStrains, allTypes] = await Promise.all([
          fetchStrains(),
          getTypes(),
        ]);
        setStrains(allStrains);
        setTypes(allTypes);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  return { strains, types, loading, error };
}

export function useStrainsByType(type) {
  const [strains, setStrains] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getStrainsByType(type)
      .then(setStrains)
      .finally(() => setLoading(false));
  }, [type]);

  return { strains, loading };
}